import {LitElement, html} from 'lit';
import {property, customElement} from 'lit/decorators.js';
import {ElementUtil} from '../../utils/elementUtil.js';
import {BaseComponent} from '../basecomponent.js';

/* global customElements */
class HighlightFieldsSelection extends BaseComponent {

	static get properties() {
		return {
			// Required so dl-form-panel.getData() includes this control (child.name).
			name: {type: String}
		};
	}

	constructor() {
		super();

		var highlightFieldsSelection = this;

		setTimeout(function(){
			highlightFieldsSelection.init();
		});
	}

	render() {
		return html`
			<style>
				.container {
					width: 100%;
					display: flex;
					flex-direction: row;
				}

				.selection-text {
					flex: 1;
					margin-left: 10px;
					border: 1px dashed grey;
					padding: 5px;
					height: 30px;
				}

			</style>
			<div class="container">
				<vaadin-button itemid='select' @click='${this.clickSelect}'>
					<vaadin-icon icon="vaadin:flash"></vaadin-icon> Highlight Fields
				</vaadin-button>
				<span itemid='text' class="selection-text">
					None
				</span>
			</div>
		`;
	}

	init() {
		var highlightFieldsSelection = this;

		highlightFieldsSelection.value = {
			highlightMissingDistance: false,
			highlightMissingFuel: false,
			highlightOutsideRange: false,
			highlightRangeStart: null,
			highlightRangeEnd: null
		};

		highlightFieldsSelection.updateSummaryText();

		var readyEvent = new CustomEvent('ready', { detail: '' });
		highlightFieldsSelection.dispatchEvent(readyEvent);
	}

	formatSummary(value) {
		if (!value) {
			return 'None';
		}

		var parts = [];
		if (value.highlightMissingDistance) {
			parts.push('Missing Distance');
		}
		if (value.highlightMissingFuel) {
			parts.push('Missing Fuel');
		}
		if (value.highlightOutsideRange) {
			var rangeText = 'Outside Range';
			if (value.highlightRangeStart != null && value.highlightRangeStart !== ''
					&& value.highlightRangeEnd != null && value.highlightRangeEnd !== '') {
				rangeText += ' ' + value.highlightRangeStart + '-' + value.highlightRangeEnd;
			} else if (value.highlightRangeStart != null && value.highlightRangeStart !== '') {
				rangeText += ' From ' + value.highlightRangeStart;
			} else if (value.highlightRangeEnd != null && value.highlightRangeEnd !== '') {
				rangeText += ' To ' + value.highlightRangeEnd;
			}
			parts.push(rangeText);
		}

		if (parts.length === 0) {
			return 'None';
		}
		return parts.join(', ');
	}

	updateSummaryText() {
		var highlightFieldsSelection = this;
		var textElement = ElementUtil.query(highlightFieldsSelection, 'text');
		if (textElement) {
			textElement.innerHTML = highlightFieldsSelection.formatSummary(highlightFieldsSelection.value);
		}
	}

	clickSelect() {
		var highlightFieldsSelection = this;

		var selectWin = ElementUtil.create({
			tag: 'dl-dialog',
			title: 'Highlight Fields',
			icon: 'vaadin:flash',
			width: 520,
			height: 320,
			listeners: {
				ready: function() {
					selectWin.show();

					var formPanel = ElementUtil.create({
						tag: 'dl-form-panel',
						itemid: 'form',
						children: [
							{
								tag: 'vaadin-form-layout',
								children: [
									{
										tag: 'vaadin-checkbox',
										itemId: 'highlightMissingDistance',
										name: 'highlightMissingDistance',
										label: 'Missing Distance'
									},
									{
										tag: 'vaadin-checkbox',
										itemId: 'highlightMissingFuel',
										name: 'highlightMissingFuel',
										label: 'Missing Fuel'
									},
									{
										tag: 'vaadin-checkbox',
										itemId: 'highlightOutsideRange',
										name: 'highlightOutsideRange',
										label: 'Outside Range',
										listeners: {
											'checked-changed': function () {
												highlightFieldsSelection.syncRangeFieldState(formPanel);
											}
										}
									},
									{
										tag: 'vaadin-number-field',
										itemId: 'highlightRangeStart',
										name: 'highlightRangeStart',
										label: 'From',
										min: 0,
										step: '0.01',
										disabled: true
									},
									{
										tag: 'vaadin-number-field',
										itemId: 'highlightRangeEnd',
										name: 'highlightRangeEnd',
										label: 'To',
										min: 0,
										step: '0.01',
										disabled: true
									}
								]
							},
							{
								tag: 'vaadin-form-layout',
								children: [
									{
										tag: 'hr',
										colspan: 2
									},
									{
										tag: 'div',
										style: 'text-align: center;',
										colspan: 2,
										defaults: {
											tag: 'vaadin-button'
										},
										children: [
											{
												theme: 'primary',
												children: [
													ElementUtil.makeIcon('vaadin:check', ' Select')
												],
												listeners: {
													click: function () {
														if (formPanel.isValid()) {
															var data = formPanel.getData();
															var outsideRange = !!data.highlightOutsideRange;

															highlightFieldsSelection.value = {
																highlightMissingDistance: !!data.highlightMissingDistance,
																highlightMissingFuel: !!data.highlightMissingFuel,
																highlightOutsideRange: outsideRange,
																highlightRangeStart: outsideRange && data.highlightRangeStart != null && data.highlightRangeStart !== ''
																	? data.highlightRangeStart
																	: null,
																highlightRangeEnd: outsideRange && data.highlightRangeEnd != null && data.highlightRangeEnd !== ''
																	? data.highlightRangeEnd
																	: null
															};

															highlightFieldsSelection.updateSummaryText();
															selectWin.close();
														}
													}
												}
											},
											{
												theme: 'tertiary',
												innerHTML: 'Cancel',
												style: 'margin-left: 10px;',
												listeners: {
													click: function () {
														selectWin.close();
													}
												}
											}
										]
									}
								]
							}
						]
					});

					selectWin.addToContentElement(formPanel);

					setTimeout(function(){
						var current = highlightFieldsSelection.value || {};
						formPanel.load({
							highlightMissingDistance: !!current.highlightMissingDistance,
							highlightMissingFuel: !!current.highlightMissingFuel,
							highlightOutsideRange: !!current.highlightOutsideRange,
							highlightRangeStart: current.highlightRangeStart,
							highlightRangeEnd: current.highlightRangeEnd
						}, {
							refreshComponents: true
						});
						highlightFieldsSelection.syncRangeFieldState(formPanel);
					}, 100);
				}
			}
		});
	}

	syncRangeFieldState(formPanel) {
		var outsideRangeCheckbox = ElementUtil.query(formPanel, 'highlightOutsideRange');
		var rangeStart = ElementUtil.query(formPanel, 'highlightRangeStart');
		var rangeEnd = ElementUtil.query(formPanel, 'highlightRangeEnd');
		var enabled = outsideRangeCheckbox && outsideRangeCheckbox.checked;

		if (rangeStart) {
			rangeStart.disabled = !enabled;
			if (!enabled) {
				rangeStart.value = '';
			}
		}
		if (rangeEnd) {
			rangeEnd.disabled = !enabled;
			if (!enabled) {
				rangeEnd.value = '';
			}
		}
	}

	setCustomValue(value) {
		var highlightFieldsSelection = this;

		if (value) {
			var data = typeof value === 'string' ? JSON.parse(value) : value;
			highlightFieldsSelection.value = {
				highlightMissingDistance: !!data.highlightMissingDistance,
				highlightMissingFuel: !!data.highlightMissingFuel,
				highlightOutsideRange: !!data.highlightOutsideRange,
				highlightRangeStart: data.highlightRangeStart != null ? data.highlightRangeStart : null,
				highlightRangeEnd: data.highlightRangeEnd != null ? data.highlightRangeEnd : null
			};
			highlightFieldsSelection.updateSummaryText();
		}
	}

	getCustomValue() {
		var highlightFieldsSelection = this;
		if (!highlightFieldsSelection.value) {
			highlightFieldsSelection.value = {
				highlightMissingDistance: false,
				highlightMissingFuel: false,
				highlightOutsideRange: false,
				highlightRangeStart: null,
				highlightRangeEnd: null
			};
		}
		return highlightFieldsSelection.value;
	}

}
customElements.define('dl-highlight-fields-selection', HighlightFieldsSelection);
